/* ============================================================
   Lucra Theme — lucra.js  ·  vanilla, sin dependencias
   Carga con defer. Todo es defensivo: si un módulo no aplica
   a la página, simplemente no hace nada.
   ============================================================ */
(function () {
  "use strict";
  var T = window.LucraTheme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ----------
     Respeta la semántica del token de shop.money_format (como Dawn):
     amount / amount_no_decimals / amount_with_comma_separator / etc.
     En LATAM (COP/CLP/ARS) el default es *_comma_separator: miles con "."
     y decimales con "," — si el JS repinta distinto al Liquid, el precio
     "cambia" en pantalla y mata la confianza. */
  function conSeparadores(cents, decimales, miles, coma) {
    var parts = (cents / 100).toFixed(decimales).split(".");
    var enteros = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
    return parts[1] ? enteros + coma + parts[1] : enteros;
  }
  function formatMoney(cents) {
    var fmt = T.moneyFormat || "${{amount}}";
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = m ? m[1] : "amount";
    var amount;
    switch (token) {
      case "amount_no_decimals": amount = conSeparadores(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": amount = conSeparadores(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": amount = conSeparadores(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": amount = conSeparadores(cents, 2, "'", "."); break;
      case "amount_no_decimals_with_space_separator": amount = conSeparadores(cents, 0, " ", ","); break;
      case "amount_with_space_separator": amount = conSeparadores(cents, 2, " ", ","); break;
      case "amount_with_period_and_space_separator": amount = conSeparadores(cents, 2, " ", "."); break;
      default: amount = conSeparadores(cents, 2, ",", "."); break;
    }
    return m ? fmt.replace(m[0], amount) : fmt + amount;
  }
  window.lucraFormatMoney = formatMoney;

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null,
    open: function () {
      this.drawer = this.drawer || $("[data-lucra-drawer]");
      if (this.drawer) { this.drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; }
    },
    close: function () {
      if (this.drawer) { this.drawer.classList.remove("is-open"); document.body.style.overflow = ""; }
    },
    refresh: function () {
      return fetch(T.routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent("lucra:cart:update", { detail: cart }));
          $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          return cart;
        });
    },
    add: function (form, btn) {
      var fd = new FormData(form);
      /* Estado cargando por CLASE (spinner en CSS): jamás tocar textContent/innerHTML,
         eso destruiría el markup interno (ícono + spans del botón COD, span data-atc-text). */
      if (btn) { btn.setAttribute("aria-disabled", "true"); btn.classList.add("is-loading"); }
      return fetch(T.routes.cart_add, { method: "POST", headers: { Accept: "application/json" }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw res.data;
          return Cart.refresh().then(function () {
            if (T.cartType === "drawer") Cart.open();
            else window.location = T.routes.cart;
          });
        })
        .catch(function (e) { document.dispatchEvent(new CustomEvent("lucra:cart:error", { detail: e })); })
        .finally(function () { if (btn) { btn.removeAttribute("aria-disabled"); btn.classList.remove("is-loading"); } });
    }
  };
  window.LucraCart = Cart;

  /* ---------- Aviso de error del carrito (nunca fallar mudo) ---------- */
  var toastTimer = null;
  function showCartToast(msg) {
    var el = $("[data-lucra-toast]");
    if (!el) {
      el = document.createElement("div");
      el.className = "lucra-toast";
      el.setAttribute("data-lucra-toast", "");
      el.setAttribute("role", "alert");
      document.body.appendChild(el);
    }
    el.textContent = msg;
    /* reflow para que la transición corra aunque el toast recién se creó */
    void el.offsetWidth;
    el.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("is-visible"); }, 5000);
  }
  document.addEventListener("lucra:cart:error", function (e) {
    var d = e.detail || {};
    /* description = mensaje humano de Shopify (ej. tope de inventario).
       message solo sirve si vino con status (error de la API, no "Failed to fetch"). */
    var msg = (typeof d.description === "string" && d.description) ||
              (d.status && typeof d.message === "string" && d.message) ||
              (T.strings && T.strings.cartError) ||
              "No pudimos agregarlo al carrito. Intentá de nuevo.";
    try { showCartToast(msg); }
    catch (err) {
      /* red de seguridad: si ni el aviso se pudo mostrar, que el flujo no muera en silencio */
      window.location = (T.routes && T.routes.cart) || "/cart";
    }
  });

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-cart-open]");
    if (openBtn) { e.preventDefault(); Cart.open(); }
    if (e.target.closest("[data-cart-close]") || e.target.matches(".lucra-drawer__overlay")) Cart.close();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { Cart.close(); closeAllPopups(); } });

  /* product / atc forms */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    Cart.add(form, form.querySelector('[type="submit"]'));
  });

  /* quantity changes inside drawer (delegated) */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-step]");
    if (step) {
      var input = step.parentNode.querySelector("input");
      if (input) { input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10)); input.dispatchEvent(new Event("change", { bubbles: true })); }
    }
  });
  document.addEventListener("change", function (e) {
    var line = e.target.closest("[data-line-key]");
    if (!line || !e.target.matches("input[type=number]")) return;
    fetch(T.routes.cart_change, {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: line.dataset.lineKey, quantity: parseInt(e.target.value, 10) || 0 })
    }).then(function () { Cart.refresh().then(function (cart) { renderDrawer(cart); renderCartPage(cart); }); });
  });

  function renderDrawer(cart) {
    document.dispatchEvent(new CustomEvent("lucra:drawer:render", { detail: cart }));
  }

  /* cart PAGE totals: sin esto, la vista de /cart queda con los números que
     imprimió Liquid mientras el server ya cambió — veneno para confianza COD */
  function renderCartPage(cart) {
    var page = $("[data-cart-page]");
    if (!page) return;
    if (cart.item_count === 0) { window.location.reload(); return; }
    var byKey = {};
    cart.items.forEach(function (it) { byKey[it.key] = it; });
    $$("[data-line-key]", page).forEach(function (line) {
      var it = byKey[line.dataset.lineKey];
      if (!it) { line.remove(); return; }
      var price = line.querySelector("[data-line-total]");
      if (price) price.textContent = formatMoney(it.final_line_price);
      var input = line.querySelector("input[type=number]");
      if (input && document.activeElement !== input && parseInt(input.value, 10) !== it.quantity) input.value = it.quantity;
    });
    var sub = $("[data-cart-subtotal]", page);
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  /* free shipping bar */
  document.addEventListener("lucra:cart:update", function (e) {
    var cart = e.detail;
    $$("[data-freebar]").forEach(function (bar) {
      var threshold = parseInt(bar.dataset.freebar, 10) * 100;
      if (!threshold) return;
      var fill = bar.querySelector(".lucra-freebar__fill");
      var msg = bar.querySelector("[data-freebar-msg]");
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      if (fill) fill.style.width = pct + "%";
      if (msg) {
        if (cart.total_price >= threshold) msg.textContent = msg.dataset.unlocked || "¡Envío gratis desbloqueado!";
        else msg.textContent = (msg.dataset.remaining || "Te faltan {amount} para envío gratis").replace("{amount}", formatMoney(threshold - cart.total_price));
      }
    });
  });

  /* ---------- Teardown en el editor de temas ----------
     shopify:section:load reemplaza el DOM de la sección, pero timers y
     observers viejos quedan vivos apuntando a nodos sueltos: cada edición
     apilaba otro interval de 1s + otro observer y la vista previa se ponía
     lenta justo cuando el comerciante evalúa el theme. Cada init anota acá
     su limpieza; barrerMuertos() suelta lo que ya no está en el documento.
     En storefront no corre nunca (section:load es solo del editor). */
  var vivos = []; /* { el, off } */
  function anotarVivo(el, off) { vivos.push({ el: el, off: off }); }
  function barrerMuertos() {
    vivos = vivos.filter(function (v) {
      if (v.el.isConnected) return true;
      try { v.off(); } catch (e) {}
      return false;
    });
  }

  /* ---------- Sticky ATC ---------- */
  /* La barra y el ancla viven en secciones DISTINTAS: si cualquiera de las
     dos se recarga en el editor hay que volver a observar el ancla nueva.
     Un solo observer vivo a la vez — el anterior siempre se desconecta. */
  var stickyIo = null;
  function initStickyAtc() {
    if (stickyIo) { stickyIo.disconnect(); stickyIo = null; }
    var bar = $("[data-sticky-atc]");
    if (!bar) return;
    var anchor = $("[data-atc-anchor]") || $('form[action*="/cart/add"]');
    if (!anchor) return;
    stickyIo = new IntersectionObserver(function (entries) {
      bar.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { threshold: 0 });
    stickyIo.observe(anchor);
  }

  /* ---------- Countdown ---------- */
  /* end_date es texto libre en el editor: si el comerciante escribe dd/mm/aaaa
     (su formato natural) o "2026-12-31 23:59" (Safari no lo parsea), new Date()
     da NaN y el contador quedaría clavado en NaN:NaN:NaN para siempre.
     Acá primero RESCATAMOS los formatos típicos y solo devolvemos NaN si de
     verdad no hay fecha — el caller entonces esconde el contador, jamás lo
     arranca roto. dd/mm SIEMPRE se lee al estilo LATAM (nunca mes/día). */
  function parseCdDate(raw) {
    var str = String(raw || "").trim();
    if (!str) return NaN;
    /* dd/mm/aaaa (también dd-mm-aaaa / dd.mm.aaaa), hora opcional; sin hora = fin del día */
    var m = str.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})(?:[\sT]+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
    if (m && +m[1] >= 1 && +m[1] <= 31 && +m[2] >= 1 && +m[2] <= 12) {
      /* con hora explícita pero sin segundos, termina en :00 (no hereda el :59 del fin de día) */
      return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 23), +(m[5] || 59), m[4] ? +(m[6] || 0) : 59).getTime();
    }
    var t = new Date(str).getTime();
    if (isFinite(t)) return t;
    /* Safari: "2026-12-31 23:59" (espacio en vez de T) no parsea — normalizar */
    return new Date(str.replace(/^(\d{4}-\d{1,2}-\d{1,2})\s+/, "$1T")).getTime();
  }
  function initCountdowns(root) {
    $$("[data-countdown]", root).forEach(function (el) {
      if (el.dataset.lucraInit) return;
      el.dataset.lucraInit = "1";
      var end;
      if (el.dataset.countdown === "evergreen") {
        var mins = parseInt(el.dataset.minutes, 10) || 30;
        var key = "lucra_eg_" + (el.dataset.id || "x");
        /* getItem también LANZA (Safari cookies bloqueadas / WebView sin DOM storage):
           sin red, el throw abortaría boot() y la landing quedaría invisible. */
        var saved = null;
        try { saved = localStorage.getItem(key); } catch (e) {}
        end = saved ? parseInt(saved, 10) : Date.now() + mins * 60000;
        /* isFinite: un valor guardado corrupto daría NaN, y NaN < Date.now()
           es false — sin este guard el contador pintaría NaN para siempre. */
        if (!saved || !isFinite(end) || end < Date.now()) { end = Date.now() + mins * 60000; }
        try { localStorage.setItem(key, end); } catch (e) {}
      } else {
        end = parseCdDate(el.dataset.countdown);
        if (!isFinite(end)) {
          /* Fecha inválida o vacía: NUNCA arrancar el timer (pintaría "NaN" cada
             segundo). Se esconde la envoltura del contador — la banda entera en
             la sección Contador, el bloque "termina en …" en la barra de anuncios —
             para que el visitante no vea un reloj roto. */
          var wrap = el.closest("[data-cd-root], .lann__cd") || el;
          if (window.Shopify && window.Shopify.designMode) {
            /* En el EDITOR jamás esconder en silencio: el comerciante creería
               que la sección se rompió. Se reemplazan los dígitos por el aviso
               con el formato correcto (solo se ve en el editor, nunca en vivo). */
            var aviso = document.createElement("div");
            aviso.setAttribute("data-cd-aviso", "");
            aviso.setAttribute("role", "alert");
            aviso.style.cssText = "font:600 13px/1.5 system-ui,sans-serif;padding:10px 14px;border:1px dashed currentColor;border-radius:8px;max-width:38ch;margin:0 auto;opacity:.92;text-align:center;";
            aviso.textContent = "⚠ Fecha inválida — escribí 2026-12-31T23:59:59 o 31/12/2026 23:59. En la tienda este contador se oculta solo.";
            el.style.display = "none";
            el.parentNode.insertBefore(aviso, el);
            return;
          }
          wrap.setAttribute("hidden", "");
          wrap.style.display = "none";
          return;
        }
      }
      function tick() {
        var d = Math.max(0, end - Date.now());
        var days = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        set(el, "d", days); set(el, "h", h); set(el, "m", m); set(el, "s", s);
        if (d <= 0) { clearInterval(iv); el.dispatchEvent(new CustomEvent("lucra:countdown:end")); }
      }
      function set(node, u, v) { var n = node.querySelector("[data-unit=" + u + "]"); if (n) n.textContent = (v < 10 ? "0" : "") + v; }
      tick(); var iv = setInterval(tick, 1000);
      /* si el editor reemplaza la sección, el nodo queda suelto y el barrido
         mata este interval (clearInterval doble es inofensivo) */
      anotarVivo(el, function () { clearInterval(iv); });
    });
  }

  /* ---------- Popups ---------- */
  function closeAllPopups() { $$("[data-popup].is-open").forEach(function (p) { p.classList.remove("is-open"); }); }
  function initPopups() {
    $$("[data-popup]").forEach(function (pop) {
      var id = pop.dataset.popup;
      var freq = pop.dataset.freq || "session";
      var trigger = pop.dataset.trigger || "time";
      var delay = parseInt(pop.dataset.delay, 10) || 5;
      var key = "lucra_popup_" + id;
      function seen() {
        if (freq === "always") return false;
        /* storage puede LANZAR (Safari cookies bloqueadas / WebView): sin storage,
           tratamos el popup como no visto — mejor mostrarlo de más que romper el JS. */
        var v = null;
        try { v = localStorage.getItem(key); } catch (e) {}
        if (!v) return false;
        if (freq === "session") {
          var s = null;
          try { s = sessionStorage.getItem(key); } catch (e) {}
          return s === "1";
        }
        if (freq === "day") return (Date.now() - parseInt(v, 10)) < 864e5;
        return true;
      }
      function show() {
        if (seen() || $(".lucra-popup.is-open")) return;
        pop.classList.add("is-open");
        try { localStorage.setItem(key, Date.now()); sessionStorage.setItem(key, "1"); } catch (e) {}
      }
      if (trigger === "time") setTimeout(show, delay * 1000);
      if (trigger === "scroll") {
        var onScroll = function () { if (window.scrollY / (document.body.scrollHeight - innerHeight) > 0.45) { show(); window.removeEventListener("scroll", onScroll); } };
        window.addEventListener("scroll", onScroll, { passive: true });
      }
      if (trigger === "exit") {
        document.addEventListener("mouseleave", function (e) { if (e.clientY <= 0) show(); });
      }
      pop.addEventListener("click", function (e) { if (e.target.closest("[data-popup-close]") || e.target === pop) pop.classList.remove("is-open"); });
    });
  }

  /* ---------- Before / After ----------
     Los listeners de window van UNA sola vez (delegados sobre el slider
     activo): antes cada re-init del editor sumaba otro par pointermove/
     pointerup jamás removido, y cada duplicado hacía getBoundingClientRect
     + 2 escrituras de estilo por movimiento al arrastrar. */
  var baActivo = null;
  function moverBa(ba, x) {
    var after = ba.querySelector(".lucra-ba__after");
    var handle = ba.querySelector(".lucra-ba__handle");
    if (!after || !handle) return;
    var rect = ba.getBoundingClientRect();
    var pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
    after.style.width = pct + "%"; handle.style.left = pct + "%";
  }
  window.addEventListener("pointermove", function (e) { if (baActivo) moverBa(baActivo, e.clientX); });
  window.addEventListener("pointerup", function () { baActivo = null; });
  function initBeforeAfter(root) {
    $$("[data-ba]", root).forEach(function (ba) {
      if (ba.dataset.lucraInit) return;
      ba.dataset.lucraInit = "1";
      /* el pointerdown vive en el nodo: muere solo cuando el editor lo reemplaza */
      ba.addEventListener("pointerdown", function (e) { baActivo = ba; moverBa(ba, e.clientX); });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    $$("[data-tabs]", root).forEach(function (tabs) {
      if (tabs.dataset.lucraInit) return;
      tabs.dataset.lucraInit = "1";
      var btns = $$("[data-tab]", tabs);
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          btns.forEach(function (b) { b.setAttribute("aria-selected", "false"); });
          $$("[data-panel]", tabs).forEach(function (p) { p.hidden = true; });
          btn.setAttribute("aria-selected", "true");
          var panel = $('[data-panel="' + btn.dataset.tab + '"]', tabs);
          if (panel) panel.hidden = false;
        });
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  /* Un ÚNICO observer para toda la vida de la página: crear uno nuevo por
     cada section:load duplicaba observers sin disconnect. Cada elemento se
     observa una sola vez (flag) y se suelta al entrar o al quedar huérfano.
     FAIL-OPEN por diseño: el CSS solo esconde bajo html.lucra-anim, y esa
     clase se prende ACÁ, al final, con lo visible ya marcado .is-in. Si este
     archivo no llega o algo revienta antes, la landing pinta completa. */
  var revealIo = null;
  function initReveal(root) {
    if (document.body.dataset.anim !== "true") return;
    /* Sin observer no hay quién revele; con movimiento reducido no se
       esconde nada (promesa del ajuste "Animaciones"). En ambos casos:
       jamás prender la clase = todo visible. */
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!revealIo) {
      revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); revealIo.unobserve(en.target); } });
      }, { threshold: 0.12 });
    }
    $$(".lucra-reveal", root).forEach(function (el) {
      if (el.dataset.lucraReveal) return;
      el.dataset.lucraReveal = "1";
      /* Lo que ya está a la vista (o quedó arriba porque el visitante
         scrolleó antes de que corriera el JS) se marca .is-in SINCRÓNICO,
         antes de prender la clase: el hero/banner (LCP) nunca parpadea ni
         espera al observer. Solo lo que entra por scroll se anima. */
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add("is-in"); return; }
      revealIo.observe(el);
      anotarVivo(el, function () { revealIo.unobserve(el); });
    });
    document.documentElement.classList.add("lucra-anim");
  }

  /* ---------- Boot ---------- */
  /* Cada init corre AISLADO: un throw en uno (o provocado por el DOM que
     inyecta una app de terceros) no puede tumbar a los demás — antes una
     excepción en initStickyAtc dejaba sin contador, sin reveal y sin Cart
     a la landing entera. */
  function correr(fns, root) {
    fns.forEach(function (fn) {
      try { fn(root); } catch (e) { if (window.console && console.error) console.error("[lucra]", e); }
    });
  }
  function boot() {
  function pintarLatido(r) {
    try {
      if (!r || !r.estado || r.estado === "activa") return;
      if (document.querySelector("[data-lucra-latido]")) return;
      var b = r.banner || {};
      if (!b.mostrar || !b.mensaje) return;
      /* VENCIDA o BLOQUEADA ⇒ pantalla completa: la tienda queda inutilizable
         hasta activar. En GRACIA sigue siendo solo la barra de aviso. */
      /* Eric 2026-08-06: UNA sola UI. Vencida o bloqueada ⇒ la tienda lleva a
         la página de licencia de LUCRA (la misma que ya le gustó, con logo,
         precio y las dos vías). Se elimina el muro propio: menos código, un
         solo lugar donde mantener el diseño y el copy. */
      if (r.estado === "vencida" || r.estado === "bloqueada") {
        var muro = document.getElementById("lucra-muro");
        if (!muro) { return; }
        function pon(sel, txt, href) {
          var n = muro.querySelector(sel);
          if (!n) { return; }
          if (txt != null) { n.textContent = txt; }
          if (href) { n.href = href; }
          n.hidden = false;
        }
        var m = muro.querySelector("[data-muro-msg]");
        if (m) { m.textContent = String(b.mensaje || ""); }
        if (b.precio) {
          var pr = muro.querySelector("[data-muro-precio]");
          if (pr) { pr.querySelector("strong").textContent = String(b.precio); pr.hidden = false; }
          pon("[data-muro-sub]", null);
        }
        if (b.url_pago) { pon("[data-muro-pago]", b.precio ? "Activar licencia — " + b.precio + "/mes" : "Activar licencia", String(b.url_pago)); }
        if (b.url_plan) { pon("[data-muro-o]", null); pon("[data-muro-plan]", null, String(b.url_plan)); }
        muro.hidden = false;
        document.documentElement.style.overflow = "hidden";
        return;
      }
      var bar = document.createElement("div");
      bar.setAttribute("data-lucra-latido", "");
      bar.className = "lucra-latido" + (r.estado === "bloqueada" ? " lucra-latido--top" : "");
      var span = document.createElement("span");
      span.textContent = String(b.mensaje);
      bar.appendChild(span);
      if (b.url_pago) {
        var a = document.createElement("a");
        a.href = String(b.url_pago);
        a.target = "_blank";
        a.rel = "noopener";
        a.textContent = "Activar licencia →";
        bar.appendChild(a);
      }
      if (b.url_plan) {
        var a2 = document.createElement("a");
        a2.href = String(b.url_plan);
        a2.target = "_blank";
        a2.rel = "noopener";
        a2.className = "lucra-latido__alt";
        a2.textContent = "o activá tu plan de LUCRA";
        bar.appendChild(a2);
      }
      document.body.appendChild(bar);
      if (r.estado === "bloqueada") {
        var marca = document.createElement("div");
        marca.className = "lucra-latido__marca";
        marca.textContent = "Tema sin licencia";
        document.body.appendChild(marca);
      }
    } catch (e) { /* fail-open: jamás romper la tienda por un aviso */ }
  }

  var latidoUltimo = null;
  function initLatido() {
    if (window.Shopify && window.Shopify.designMode) return; /* nunca en el editor */
    var cfg = (T.latido) || {};
    var shop = cfg.shop || (window.Shopify && window.Shopify.shop) || "";
    if (!shop) return;
    /* Eric 2026-08-06: el estado debe verse EN VIVO. Antes se cacheaba 6 h y
       había que abrir incógnito para ver un cambio. Ahora: 60 s de caché
       (protege a LUCRA de una llamada por pageview), revalidación al volver a
       la pestaña, y ?licencia=1 fuerza consulta inmediata. */
    var KEY = "lucra_latido_v1";
    var TTL = 60000;
    var forzar = false;
    try { forzar = /[?&]licencia=1\b/.test(window.location.search); } catch (e) {}
    if (forzar) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) {}
    if (!forzar && cached && cached.t && (Date.now() - cached.t) < TTL && cached.r) { pintarLatido(cached.r); return; }
    var api = cfg.url || "https://ecomlucra.com/api/theme/latido";
    /* lucra-id.json (rastreador del build) — si no existe o falla, se manda sin él */
    var idUrl = cfg.idAsset;
    if (!idUrl) {
      var propio = $$('script[src*="lucra.js"]')[0];
      if (propio && propio.src) idUrl = propio.src.replace(/lucra\.js[^/]*$/, "lucra-id.json");
    }
    var pId = idUrl
      ? fetch(idUrl).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      : Promise.resolve(null);
    pId.then(function (id) {
      return fetch(api, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: shop, version: (id && id.version) || null, buildId: (id && id.buildId) || null })
      });
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || j.ok !== true) return; /* respuesta rara → nada visible */
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), r: j })); } catch (e) {}
        if (latidoUltimo !== j.estado) {
          var previo = document.querySelectorAll("[data-lucra-latido]");
          for (var q = 0; q < previo.length; q++) { previo[q].remove(); }
          var muroPrevio = document.getElementById("lucra-muro");
          if (muroPrevio) { muroPrevio.hidden = true; }
          document.documentElement.style.overflow = "";
        }
        latidoUltimo = j.estado;
        pintarLatido(j);
        /* Mientras la licencia NO esté al día, se revisa cada 15 s: apenas el
           dueño paga, la tienda se destraba sola sin que nadie recargue. */
        if (j.estado !== "activa" && !window.__lucraRondaLic) {
          window.__lucraRondaLic = setInterval(function () {
            try { localStorage.removeItem("lucra_latido_v1"); initLatido(); } catch (e) {}
          }, 15000);
        } else if (j.estado === "activa" && window.__lucraRondaLic) {
          clearInterval(window.__lucraRondaLic);
          window.__lucraRondaLic = null;
        }
      })
      .catch(function () { /* LUCRA caída / sin red → la tienda sigue normal */ });
  }

  /* ---------- Boot ---------- */
  /* Cada init corre AISLADO: un throw en uno (o provocado por el DOM que
     inyecta una app de terceros) no puede tumbar a los demás — antes una
     excepción en initStickyAtc dejaba sin contador, sin reveal y sin Cart
     a la landing entera. */
  function correr(fns, root) {
    fns.forEach(function (fn) {
      try { fn(root); } catch (e) { if (window.console && console.error) console.error("[lucra]", e); }
    });
  }

    correr([initStickyAtc, initCountdowns, initPopups, initBeforeAfter, initTabs, initReveal, initLatido]);
    /* Al volver a la pestaña la consulta IGNORA la caché (tope: 1 cada 15 s)
       ⇒ cambiás el estado en el panel, volvés a la tienda y se ve al toque. */
    var ultimoForzado = 0;
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { return; }
      var ahora = Date.now();
      if (ahora - ultimoForzado < 15000) { return; }
      ultimoForzado = ahora;
      try { localStorage.removeItem("lucra_latido_v1"); } catch (err) {}
      try { initLatido(); } catch (err) {}
    });
    Cart.refresh();
    /* Editor de temas: primero barrer lo que quedó apuntando a nodos
       reemplazados, después re-inicializar SOLO la sección recargada
       (e.target). Sticky ATC es la excepción cross-sección: se rehace
       global, pero es idempotente (un solo observer vivo). */
    document.addEventListener("shopify:section:load", function (e) {
      barrerMuertos();
      var root = e.target || document;
      correr([initStickyAtc], undefined);
      correr([initCountdowns, initBeforeAfter, initTabs, initReveal], root);
    });
    document.addEventListener("shopify:section:unload", barrerMuertos);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
